import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-secure-site-label',
  templateUrl: './secure-site-label.component.html',
  styleUrls: ['./secure-site-label.component.scss']
})
export class SecureSiteLabelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
